import { render, staticRenderFns } from "./ruleschool-add-or-update.vue?vue&type=template&id=0802eed2&"
import script from "./ruleschool-add-or-update.vue?vue&type=script&lang=js&"
export * from "./ruleschool-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports